import React from 'react';
import styled from 'styled-components';
import { renderStyledElementStyles } from '../../../../helpers';

export const StyledMenuItemWrapper = styled.div`
  cursor: pointer;
  padding: 8px 16px;
  white-space: nowrap;

  ${({ theme }) =>
    renderStyledElementStyles(
      theme,
      theme.module.dStyles.elements.menu?.elements?.menuItem,
    )}
  ${({ theme }) =>
    renderStyledElementStyles(
      theme,
      theme.module.vStyles.elements.menu?.elements?.menuItem,
    )}

  ${({ theme, selected }: { selected: boolean; theme: any }) =>
    selected &&
    renderStyledElementStyles(
      theme,
      theme.module.vStyles.elements.menu?.elements?.menuItem?.selected,
    )}
`;

export const StyledMenuItemText = styled.p`
  ${({ theme }) =>
    renderStyledElementStyles(
      theme,
      theme.module.dStyles.elements.menu?.elements?.menuItem?.elements?.text,
    )}
  ${({ theme }) =>
    renderStyledElementStyles(
      theme,
      theme.module.vStyles.elements.menu?.elements?.menuItem?.elements?.text,
    )}
`;

export type StyledMenuItemProps = {
  label: string;
  selected: boolean;
  onClick: () => void;
};

export const StyledMenuItem = ({
  selected,
  label,
  onClick,
}: StyledMenuItemProps) => {
  return (
    <StyledMenuItemWrapper onClick={onClick} selected={selected}>
      <StyledMenuItemText>{label}</StyledMenuItemText>
    </StyledMenuItemWrapper>
  );
};
